<template>
  <!--    FIXME style-->
  <div
    v-show="seen"
    id="loginPage"
    class="container main-content"
  >
    <div class="row">
      <div class="col-xs-12">
        <img
          alt=""
          src="/img/header.png"
          class="img-responsive drop-shadow"
        >
      </div>
    </div>
    <div
      v-if="serverSettingsLoaded"
      class="col-xs-12"
    >
      <div class="row well white-gradient-background border-radius-large box-shadow">
        <div class="col-xs-12 col-sm-6">
          <!--        <h3>{{ $t('login.information') }}</h3>-->
          <ul class="list-group push-down">
            <li class="list-group-item info">
              <strong v-if="$t('login.login_info_title') !== ''">{{ $t('login.login_info_title') }}<br></strong>
              <p v-html="$t('login.login_info')" />
            </li>
          </ul>
        </div>

        <div class="col-xs-12 col-sm-6 border-radius-large tile-contrast">
          <div class="row">
            <div class="col-xs-12">
              <form
                class="form-signin"
                @submit.prevent="signIn"
              >
                <h1
                  class="form-signin-heading pull-left"
                  style="max-width: 350px; font-size: 30px;"
                >
                  {{ $t('navbar.passenger_portal') }}
                </h1>
                <LanguageSelector />
                <label
                  for="loginUsername"
                  class="sr-only"
                >{{ $t('login.username') }}</label>
                <input
                  id="loginUsername"
                  v-model="username"
                  type="text"
                  class="form-control"
                  :placeholder="$t('login.username')"
                  required
                  autofocus
                  :disabled="processingForm"
                  autocomplete="username"
                >
                <label
                  for="loginPassword"
                  class="sr-only"
                >{{ $t('login.password') }}</label>
                <input
                  id="loginPassword"
                  v-model="password"
                  type="password"
                  class="form-control"
                  :placeholder="$t('login.password')"
                  required
                  :disabled="processingForm"
                  autocomplete="current-password"
                >
                <button
                  id="signInBtn"
                  class="btn btn-lg btn-primary btn-block border-radius-small"
                  type="submit"
                  :disabled="processingForm"
                >
                  {{ $t('login.sign_in') }}
                </button>
              </form>
            </div>
            <div class="col-xs-12 text-center signin-links">
              <div class="row">
                <div class="col-xs-6">
                  <p>{{ $t('login.dont_have_account_yet') }}</p>
                  <a
                    href="#"
                    :aria-label="$t('login.dont_have_account_yet') + $t('login.register')"
                    @click.prevent="createAccountModalOpened=true"
                  >{{ $t('login.register') }}</a> |
                  <a
                    v-tooltip="{
                      content: $t('cards.payments_history.download_receipt_tooltip'),
                      disabled: !json.oct_download_receipt_tooltip
                    }"
                    href="#"
                    :aria-label="$t('login.dont_have_account_yet') + $t('cards.payments_history.download_receipt') + '. ' + $t('cards.payments_history.download_receipt_tooltip')"
                    @click.prevent="downloadReceiptModalOpened=true"
                  >{{ $t('cards.payments_history.download_receipt') }}</a>
                </div>
                <div class="col-xs-6">
                  <p>{{ $t('login.forgot_password') }}</p>
                  <a
                    href="#"
                    :aria-label="$t('login.forgot_password') + $t('login.reset_password')"
                    @click.prevent="resetPasswordModalOpened=true"
                  >{{ $t('login.reset_password') }}</a>
                </div>
              </div>
            </div>
            <focus-trap v-model="createAccountModalOpened">
              <LoginCreateAccount v-model="createAccountModalOpened" />
            </focus-trap>
            <focus-trap v-model="downloadReceiptModalOpened">
              <DownloadReceipt v-model="downloadReceiptModalOpened" />
            </focus-trap>
            <focus-trap v-model="resetPasswordModalOpened">
              <PasswordReset v-model="resetPasswordModalOpened" />
            </focus-trap>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { Users, SSO } from '@/api/AuthService'
import PortalBackend from '@/api/PortalBackendService'
import LoginCreateAccount from '@/views/LoginCreateAccount'
import {mapActions} from 'vuex'
import LanguageSelector from '@/components/LanguageSelector'
import DownloadReceipt from '@/views/DownloadReceipt'
import PasswordReset from '@/views/PasswordReset'
import json from '@/configuration.json'
import Footer from '@/components/Footer'
import Vue from 'vue'

export default {
  components: {LanguageSelector, PasswordReset, LoginCreateAccount, DownloadReceipt, Footer},
  data() {
    return {
      username: '',
      password: '',
      createAccountModalOpened: false,
      downloadReceiptModalOpened: false,
      resetPasswordModalOpened: false,
      processingForm: false,
      serverSettingsLoaded: false,
      seen: true,
      json: json
    }
  },
  created() {
    SSO
      .getServerSettings(window.location.host)
      .then((data) => {
        if (data['oidc_configuration'] && data['oidc_configuration']['enabled']) {

          Vue.prototype.$sso=data['oidc_configuration']

          this.seen = false
          if (data['oidc_configuration']['authorized']) {
            Users.getUserSettings()
              .then(() => {
                // noinspection JSVoidFunctionReturnValueUsed
                Users
                  .isLogged(window.location.pathname)
                  .then(() => {
                    this.$router.push('/')
                  }).catch(async () => {
                    await this.logout()
                    if (data['oidc_configuration']['discovery'] && data['oidc_configuration']['discovery']['authorization']) {
                      window.location = data['oidc_configuration']['discovery']['authorization']
                    } else {
                      console.error('SSO enabled but authorization callback is empty!')
                    }
                  })
              })
              // Logouts user if error - means that user is not logged in
              .catch(async () => {
                await this.logout()
                if (data['oidc_configuration']['discovery'] && data['oidc_configuration']['discovery']['authorization']) {
                  window.location = data['oidc_configuration']['discovery']['authorization']
                } else {
                  console.error('SSO enabled but authorization callback is empty!')
                }
              })
            return
          }
          if (data['oidc_configuration']['discovery'] && data['oidc_configuration']['discovery']['authorization']) {
            window.location = data['oidc_configuration']['discovery']['authorization']
          } else {
            console.error('SSO enabled but authorization callback is empty!')
          }
        } else {
          this.seen = true
        }
      })
      .catch(error => {
        console.error('Get server settings error', error)
      })
      .finally(() => this.serverSettingsLoaded = true)
  },
  mounted() {
    this.setPageTitle(this.$t('login.sign_in'))
  },
  methods: {
    ...mapActions(['logout']),
    signIn() {
      const {username, password} = this
      this.processingForm = true

      if (username && password) {
        PortalBackend
          .login(username, password)
          .then(() => Users.getUserSettings())
          .then(() => this.$router.push('/'))
          .catch(e => {
            if (typeof e.response !== 'undefined' && typeof e.response.statusText !== 'undefined' && 'Unauthorized' === e.response.statusText && !e.response.data.error) {
              this.$notify({
                type: 'warning',
                title: this.$root.$t('login.wrong_credentials_title'),
                content: this.$root.$t('login.wrong_credentials_content'),
                duration: json.notification_duration.warning
              })
            } else if (typeof e.response.data.error && e.response.data.error === 'USER_LOCKED') {
              this.$notify({
                type: 'warning',
                title: this.$root.$t('login.wrong_credentials_title'),
                content: this.$root.$t('login.user_locked'),
                duration: json.notification_duration.warning
              })
            } else if (typeof e.response.data.error && e.response.data.error === 'PASSWORD_CHANGE_REQUIRED') {
              this.$notify({
                type: 'warning',
                title: this.$root.$t('login.wrong_credentials_title'),
                content: this.$root.$t('login.password_change'),
                duration: json.notification_duration.warning
              })
            } else {
              this.$notify({
                type: 'warning',
                title: this.$root.$t('login.wrong_credentials_title'),
                content: this.$root.$t('login.unexpected_error_content'),
                duration: json.notification_duration.warning
              })
            }
          })
          .finally(() => this.processingForm = false)
      }
    }
  }
}
</script>

<style lang="less">
  @import '../assets/css/bootstrap-variables.less';
  @import '../assets/css/styles.less';

  #active-lang-login {
    border-radius: 3px;
    margin: 0 0 3px 0;
  }

  .signin-links {
    margin-top: 1em;
    padding: 0 @grid-gutter-width;

    > .row {
      padding: .5em 0;
      border: @brand-blue solid 0px;
      border-radius: @border-radius-large;

      > div{

        &:nth-child(1) {
          border-right: solid @brand-blue 1px;
        }
      }

      a {
        color: @brand-blue;
      }

    }
  }

  .form-signin .form-control {
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }

  .form-signin .form-control:focus {
    z-index: 2;
  }

  .form-signin input[type="text"] {
    margin-bottom: 5px;
  }

  .form-signin input[type="password"] {
    margin-bottom: 10px;
  }

  li.info {
    min-height: 200px;
  }

  .white-gradient-background {
    @media (max-width: @screen-sm) {
      background: @blue-very-soft;
    }
    @media (min-width: @screen-sm) {
      background: linear-gradient(to right, @brand-primary 40%, @blue-very-soft 40%);
    }
    background-color: @translucent-white;
    border: 1px solid @brand-blue;
  }

  .push-down {
    margin-top: 24px;
  }

</style>
